import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { EDriversActionTypes } from "./actions";

const defaultState = {
  drivers: [],
  saving: false,
  savingError: false,
  savingSuccess: false,
  deleteSuccess: false,
  deleteFailed: false
};

const persistConfig = {
  key: "drivers",
  storage,
  whitelist: ["drivers"]
};

const driversReducer = persistReducer(
  persistConfig,
  (state = defaultState, action) => {
    switch (action.type) {
      case EDriversActionTypes.GET_DRIVERS_SUCCESS:
        return {
          ...state,
          drivers: action.payload
        };
      case EDriversActionTypes.SAVE_DRIVER:
        return {
          ...state,
          saving: true
        };
      case EDriversActionTypes.SAVING_FAILED:
        return {
          ...state,
          saving: false,
          savingError: Math.random(),
          savingSuccess: false
        };
      case EDriversActionTypes.SAVING_SUCCESS:
        return {
          ...state,
          saving: false,
          savingError: false,
          savingSuccess: Math.random()
        };
      case EDriversActionTypes.DELETING_SUCCESS:
        return {
          ...state,
          deleteSuccess: Math.random()
        };
      case EDriversActionTypes.RESET_SUCCESS_DELETE:
        return {
          ...state,
          deleteSuccess: false
        };
      case EDriversActionTypes.RESET_SUCCESS_SAVE:
        return {
          ...state,
          savingSuccess: false
        };
      default:
        return state;
    }
  }
);

export default driversReducer;
